import api from '../utils/api';
import type {
  ReminderJob,
  ReminderJobsResponse,
  ReminderJobsStats,
  ReminderJobsFilters
} from '../types/reminderJob.types';

export const reminderJobsService = {
  /**
   * Get all reminder jobs with pagination and filters
   */
  getAll: async (filters: ReminderJobsFilters = {}): Promise<ReminderJobsResponse> => {
    const params: Record<string, string | number> = {};

    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;
    if (filters.stato) params.stato = filters.stato;
    if (filters.scadenzaId) params.scadenzaId = filters.scadenzaId;
    if (filters.clienteId) params.clienteId = filters.clienteId;
    if (filters.sort) params.sort = filters.sort;

    const response = await api.get('/reminder-jobs', { params });
    return response.data;
  },

  /**
   * Get reminder jobs statistics
   */
  getStats: async (): Promise<ReminderJobsStats> => {
    const response = await api.get('/reminder-jobs/stats');
    return response.data;
  },

  /**
   * Get single reminder job by ID
   */
  getById: async (id: string): Promise<ReminderJob> => {
    const response = await api.get(`/reminder-jobs/${id}`);
    return response.data;
  }
};

export default reminderJobsService;
